import { memo } from "react";

import { capitalize } from "neetocist";
import * as Icons from "neetoicons/logos";
import { Typography } from "neetoui";
import PropTypes from "prop-types";
import { Trans } from "react-i18next";
import uppercamelcase from "uppercamelcase";

import "./made-with.scss";

const MadeWith = ({ productName, productIcon: ProductIcon, ...otherProps }) => {
  const name = capitalize(productName || globalProps.appName || "Neeto");
  const subdomain = globalProps.organization?.subdomain;
  const utmParams = `utm_source=madewith${
    subdomain ? `&utm_campaign=${subdomain}` : ""
  }`;

  const IconComponent = ProductIcon || Icons[uppercamelcase(name)];

  return (
    <a
      className="neeto-molecules-made-with__wrapper"
      data-testid={`made-with-${name.toLowerCase()}`}
      href={`https://www.neeto.com/${name.toLowerCase()}?${utmParams}`}
      rel="noreferrer"
      target="_blank"
      {...otherProps}
    >
      {IconComponent && (
        <span data-testid={`made-with-${name.toLowerCase()}-icon`}>
          <IconComponent size={14} />
        </span>
      )}
      <Typography className="leading-snug" style="body2">
        <Trans
          i18nKey="neetoMolecules.common.madeWith"
          values={{ productName: name }}
        />
      </Typography>
    </a>
  );
};

MadeWith.propTypes = {
  /**
   * Product name to be displayed on the component (optional).
   */
  productName: PropTypes.string,

  /**
   * Product icon  component to be displayed on the badge (optional).
   */
  productIcon: PropTypes.elementType,
};

export default memo(MadeWith);
